"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideObjectAttributes = void 0;
/** **MUTATES** overridable object with any common attribute overriden with same from overridableObject
 * recurses where same attribute is an object or array, but not primative
 * any  attributes in overridable object but not in overriding object are left untouched
 * any common attributes are overriden
 * any non present attributes in overridable object but presnt in overriding object are added
 * Essentially a merge with overridingObject taking precendence
 */
const overrideObjectAttributes = ({ overridableObject, overridingObject }) => {
    try {
        Object.entries(overridingObject).forEach(([k, v]) => {
            if (v instanceof Array) {
                if (overridableObject[k] instanceof Array) {
                    if (!overridableObject[k] || !(overridableObject[k] instanceof Array)) {
                        overridableObject[k] = [];
                    }
                    (0, exports.overrideObjectAttributes)({ overridableObject: overridableObject[k], overridingObject: v });
                }
                else {
                    // if a.k isn't array make it so
                    overridableObject[k] = v;
                }
            }
            else if (typeof v === 'object') {
                if (!!v) {
                    if (!overridableObject[k]) {
                        overridableObject[k] = {};
                    }
                    (0, exports.overrideObjectAttributes)({ overridableObject: overridableObject[k], overridingObject: v });
                }
                else {
                    // nulls are overriden
                    overridableObject[k] = v;
                }
            }
            else {
                overridableObject[k] = v;
            }
        });
    }
    catch (e) {
        console.log({ overridableObject, overridingObject });
        throw new Error(`Cant override: ${e.message} `);
    }
    return overridableObject;
};
exports.overrideObjectAttributes = overrideObjectAttributes;
